"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.reflect.get");

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var WithTextComponentMethods = function WithTextComponentMethods(_WithTextComponentMethods) {
  return (
    /*#__PURE__*/
    function (_WithTextComponentMet) {
      _inherits(_class, _WithTextComponentMet);

      function _class() {
        _classCallCheck(this, _class);

        return _possibleConstructorReturn(this, _getPrototypeOf(_class).apply(this, arguments));
      }

      _createClass(_class, [{
        key: "beforeSubmit",
        value: function beforeSubmit() {
          // вызываем submit у формы -> вызов submit вызывает beforeSubmit -> в компонентах обернутых
          // в WithTextComponentMethods удаляются пробелы в начале и в конце значений из getValue
          // Для чего это нужно? После того как удалены пробелы вызваем getSubmission(...)
          // и отправляем данные (уже без лишних пробелов) на сервер
          var data = this.getValue();

          if (typeof data === 'string') {
            data = data.trim();
          } else if (Array.isArray(data)) {
            data = data.map(function (valueItem) {
              if (_typeof(valueItem) === 'object' && typeof valueItem.value === 'string') {
                valueItem.value = valueItem.value.trim();
              } else if (typeof valueItem === 'string') {
                return valueItem.trim();
              }

              return valueItem;
            });
          } else if (_typeof(data) === 'object' && typeof data.value === 'string') {
            data.value = data.value.trim();
          }

          this.setValue(data);
          return _get(_getPrototypeOf(_class.prototype), "beforeSubmit", this).call(this);
        }
      }]);

      return _class;
    }(_WithTextComponentMethods)
  );
};

var _default = WithTextComponentMethods;
exports.default = _default;